import { InjectionToken } from '@angular/core';

/** Configuration for the B2B Organizations subsystem. */
export interface OrganizationsConfig {
  /**
   * Use the offline MOCK repository instead of the real `/api/v3/org/*` binding.
   * Independent of every other feature's mock flag (same rule `HOME_CONFIG`
   * follows) so B2B can be worked on offline without changing anything else.
   */
  useMock: boolean;
  /**
   * `GET /org/context` cache lifetime in ms. §2 says call it once after login and
   * again on app resume — so the store serves a cached context inside this window
   * and refetches past it, rather than re-reading on every tab switch.
   */
  contextCacheTtlMs: number;
  /**
   * Hand an SSR-fetched context to the client via TransferState.
   *
   * TRUE, but inert in practice today: `AppHttp.process()` returns `NEVER` on the
   * server by design, so no org call runs during a server render and there is
   * nothing to transfer. The flag stays wired so that if the render host ever
   * gains a session, hydration picks the value up rather than refetching — see
   * DECISIONS.md.
   */
  useTransferState: boolean;
}

export const DEFAULT_ORGANIZATIONS_CONFIG: OrganizationsConfig = {
  useMock: false, // ← real `/api/v3/org/*`
  contextCacheTtlMs: 5 * 60 * 1000,
  useTransferState: true,
};

export const ORGANIZATIONS_CONFIG = new InjectionToken<OrganizationsConfig>('ORGANIZATIONS_CONFIG', {
  providedIn: 'root',
  factory: () => DEFAULT_ORGANIZATIONS_CONFIG,
});
